import { useSelected, useFocused } from 'slate-react';
import type { RenderElementPropsFor } from '../../types';
import type { HTMLElements, Image } from './types';

export type HTMLElsProps = RenderElementPropsFor<HTMLElements>;

function ImageElement({ attributes, children, element }: RenderElementPropsFor<Image>) {
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div {...attributes}>
      {children}
      <img
        src={element.url}
        style={{
          display: 'block',
          maxWidth: 100,
          maxHeight: '20em',
          boxShadow: selected && focused ? '0 0 0 2px blue;' : 'none',
        }}
      />
    </div>
  );
}

export function HTMLEls(props: HTMLElsProps) {
  const { attributes, children, element } = props;
  switch (element.type) {
    case 'paragraph':
      return <div {...attributes}>{children}</div>;
    case 'block-quote':
      return <blockquote {...attributes}>{children}</blockquote>;
    case 'code-block':
      return (
        <pre>
          <code {...attributes}>{children}</code>
        </pre>
      );
    case 'bulleted-list':
      return <ul {...attributes}>{children}</ul>;
    case 'heading-one':
      return <h1 {...attributes}>{children}</h1>;
    case 'heading-two':
      return <h2 {...attributes}>{children}</h2>;
    case 'heading-three':
      return <h3 {...attributes}>{children}</h3>;
    case 'heading-four':
      return <h4 {...attributes}>{children}</h4>;
    case 'heading-five':
      return <h5 {...attributes}>{children}</h5>;
    case 'heading-six':
      return <h6 {...attributes}>{children}</h6>;
    case 'list-item':
      return <li {...attributes}>{children}</li>;
    case 'numbered-list':
      return <ol {...attributes}>{children}</ol>;
    case 'image':
      return (
        <ImageElement attributes={attributes} element={element}>
          {children}
        </ImageElement>
      );
    default:
      return <div {...attributes}>{children}</div>;
  }
}
